export { default as Tag } from './Tag';
export type { TagVariants, TagProps } from './Tag';